import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b86ce24"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding": "16px",
    "font-size": "14px !important",
    "background-color": "white"
  }
};
const _hoisted_2 = {
  class: "card-item-box"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "icon-box"
};
const _hoisted_5 = {
  class: "card-content"
};
const _hoisted_6 = {
  class: "card-content-title"
};
const _hoisted_7 = {
  key: 0,
  class: "card-content-count"
};
const _hoisted_8 = {
  class: "card-header"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "待办任务", -1));
const _hoisted_10 = {
  class: "quick-item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "快捷菜单", -1));
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "item-name"
};
const _hoisted_15 = {
  class: "card-header"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发文", -1));
const _hoisted_17 = {
  class: "card-header"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收文", -1));
const _hoisted_19 = {
  class: "card-header"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "采购申请", -1));
const _hoisted_21 = {
  class: "card-header"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "领用申请", -1));
import { useRouter } from 'vue-router';
import { FolderRemove, Coin, Files, Tickets, Van, VideoCamera, List, Reading, Histogram, Coordinate, Monitor, Postcard, Suitcase, DocumentAdd } from '@element-plus/icons-vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { useCommon } from '@/common/hooks/useCommon';
import { FlowOperationController } from '@/api/flow';
import { OfficeSupplyOrderController, OfficeUseApplyController, OfficialDocController, WelcomeController } from '@/api/generated';
import { SysFlowTaskOperationType } from '@/common/staticDict/flow';
import FormEditOfficialDoc from '@/pages/officialDoc/formEditOfficialDoc.vue';

import { computed, ref, inject, onMounted } from 'vue';
const __default__ = {
  name: 'Welcome'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const tabList = computed(() => {
      return [{
        color: 'bg1',
        title: '办公用品审批',
        count: countModel.value.officeCount,
        url: 'office',
        icon: Coordinate
      }, {
        color: 'bg2',
        title: '报销审批',
        count: countModel.value.reimbursementOrderCount,
        url: 'post',
        icon: Postcard
      }, {
        color: 'bg3',
        title: '公文审批',
        count: countModel.value.officialDocCount,
        url: 'word',
        icon: Monitor
      }, {
        color: 'bg4',
        title: '收文审批',
        count: countModel.value.receiveOfficialDocCount,
        url: 'receive',
        icon: DocumentAdd
      }, {
        color: 'bg1',
        title: '所有审批',
        count: countModel.value.totalCount,
        url: 'formMyTask',
        icon: Suitcase
      }];
    });
    const quickList = ref([{
      icon: Coin,
      title: '报销申请',
      url: 'formFlowReimbursementOrder'
    }, {
      icon: Monitor,
      title: '办公用品申请',
      url: 'OfficeUseApplyPageList'
    }, {
      icon: Van,
      title: '用车申请',
      url: 'formVehicleApply'
    }, {
      icon: VideoCamera,
      title: '会议预约',
      url: 'formMeetingApply'
    }, {
      icon: FolderRemove,
      title: '公文起草',
      url: 'formOfficialDoc'
    }, {
      icon: Files,
      title: '收文登记',
      url: 'formReceiveOfficialDoc'
    }, {
      icon: List,
      title: '资产采购',
      url: 'AssetPurchaseOrderFlowPage'
    }, {
      icon: Tickets,
      title: '合同登记',
      url: 'formContractInfo'
    }, {
      icon: Reading,
      title: '图书借阅',
      url: 'bookApplyList'
    }, {
      icon: Histogram,
      title: '发起投票',
      url: 'myVoteProject'
    }]);
    const {
      formatDateByStatsType,
      checkPermCodeExist,
      Dialog
    } = useCommon();
    const router = useRouter();
    const countModel = ref({});
    const operationList = ref([]);
    const officeSupplyOrderList = ref([]);
    const officeUseApplyList = ref([]);
    const officialDocWidgetDataList = ref([]);
    const receiveOfficialDocList = ref([]);
    const mainContextHeight = inject('mainContextHeight', ref(200));
    const getContentStyle = computed(() => {
      return [{
        'min-height': mainContextHeight.value - 221 - 24 - 16 + 'px'
      }];
    });
    const onPreviewClick = row => {
      let params = {
        id: row?.id
      };
      Dialog.show('预览', FormEditOfficialDoc, {
        area: '90vw'
      }, {
        ...params,
        subPage: true,
        disabled: true
      }).then(res => {
        getOfficialDocWidgetDataList();
      }).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    const onSendClick = row => {
      console.log('onSendClick', row);
      ElMessageBox.confirm('是否确认已经发文？').then(res => {
        OfficialDocController.send({
          id: row.id
        }).then(res => {
          ElMessage.success('操作成功');
        }).catch(e => {
          // TODO: 异常处理
          console.error(e);
        });
      }).catch(e => {
        console.error(e);
      });
    };
    const onCellClick = (row, column, cell, event) => {
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: row.taskId
      };
      FlowOperationController.viewRuntimeTaskInfo(params).then(res => {
        console.log('......', res);
        if (res.data) {
          router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: 'true',
              isDraft: row.isDraft,
              taskId: row.taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: row.taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.showName,
              // 过滤掉加签、减签操作，加签、减签只有在已完成任务里可以操作
              operationList: JSON.stringify((res.data.operationList || []).filter(item => {
                return item.type !== SysFlowTaskOperationType.CO_SIGN && item.type !== SysFlowTaskOperationType.REVOKE && item.type !== SysFlowTaskOperationType.SIGN_REDUCTION;
              })),
              variableList: JSON.stringify(res.data.variableList)
            }
          });
        }
      }).catch(e => {
        console.warn(e);
      });
    };
    // 入库
    const onFormOfficeStoreEditClick = (row, column, cell, event) => {
      let params = {
        id: row.id
      };
      router.push({
        name: 'formOfficeOrderStore',
        query: {
          ...params,
          saveOnSubmit: 'true',
          subPage: 'true'
        }
      });
    };
    const onOfficeUseApplyGrantClick = (row, column, cell, event) => {
      let params = {
        id: row.id
      };
      router.push({
        name: 'OfficeUseApplyGrant',
        query: {
          ...params,
          saveOnSubmit: 'true',
          subPage: 'true'
        }
      });
    };
    const clickTab = name => {
      if (name === 'formMeetingOrder' || name === 'formMyTask') {
        sessionStorage.setItem('formMyTaskType', null);
        router.push(name);
        return;
      } else {
        sessionStorage.setItem('formMyTaskType', name);
        router.push({
          name: 'formMyTask'
        });
      }
    };
    const clickMore = name => {
      // if (name === 'formOfficialDoc') {
      //   router.push({
      //     name: 'formOfficialDoc',
      //     query: { showDialog: 'true' },
      //   });
      //   return;
      // }
      router.push({
        name
      });
    };
    const getOperationList = () => {
      FlowOperationController.listRuntimeTask({
        pageParam: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(({
        data
      }) => {
        operationList.value = data.dataList || [];
      }).catch(e => {
        console.log(e);
      });
    };
    const getOfficeSupplyOrderList = () => {
      OfficeSupplyOrderController.list({
        officeSupplyOrderDtoFilter: {
          status: 2
        },
        pageParam: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(({
        data
      }) => {
        officeSupplyOrderList.value = data.dataList || [];
      }).catch(e => {
        console.log(e);
      });
    };
    const getOfficeUseApplyList = () => {
      OfficeUseApplyController.list({
        officeUseApplyDtoFilter: {
          selectType: true,
          status: 2
        },
        pageParam: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(({
        data
      }) => {
        officeUseApplyList.value = data.dataList || [];
      }).catch(e => {
        console.log(e);
      });
    };
    const getOfficialDocWidgetDataList = () => {
      OfficialDocController.list({
        officialDocDtoFilter: {
          status: 11
        },
        pageParam: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(({
        data
      }) => {
        officialDocWidgetDataList.value = data.dataList || [];
      }).catch(e => {
        console.log(e);
      });
    };
    const getReceiveOfficialDocList = () => {
      OfficialDocController.list({
        officialDocDtoFilter: {
          sendStatus: 1
        },
        pageParam: {
          pageNum: 1,
          pageSize: 5
        }
      }).then(({
        data
      }) => {
        receiveOfficialDocList.value = data.dataList || [];
      }).catch(e => {
        console.log(e);
      });
    };
    const getWelcomeSummary = () => {
      WelcomeController.summary({}).then(({
        data
      }) => {
        countModel.value = data;
      }).catch(e => {
        console.log(e);
      });
    };
    onMounted(() => {
      getOperationList();
      getOfficeSupplyOrderList();
      getOfficeUseApplyList();
      getOfficialDocWidgetDataList();
      getReceiveOfficialDocList();
      getWelcomeSummary();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_More = _resolveComponent("More");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (tab, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: $event => clickTab(tab.url),
          class: _normalizeClass(["card-item", tab.color])
        }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
          size: "26",
          color: "#fff"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon)))]),
          _: 2
        }, 1024)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(tab.title), 1), tab.count || tab.count === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(tab.count), 1)) : _createCommentVNode("", true)])], 10, _hoisted_3);
      }), 128))]), _createVNode(_component_el_card, {
        style: {
          "margin-bottom": "16px"
        }
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_icon, {
          size: "20",
          onClick: _cache[0] || (_cache[0] = $event => clickMore('formMyTask'))
        }, {
          default: _withCtx(() => [_createVNode(_component_More)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: _unref(operationList),
          style: {
            "width": "100%"
          },
          onCellClick: onCellClick
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "workOrderCode",
            label: "任务编号"
          }), _createVNode(_component_el_table_column, {
            prop: "processDefinitionName",
            label: "流程名称"
          }), _createVNode(_component_el_table_column, {
            prop: "taskName",
            label: "当前任务"
          }), _createVNode(_component_el_table_column, {
            prop: "showName",
            label: "发起人昵称"
          }), _createVNode(_component_el_table_column, {
            prop: "processInstanceStartTime",
            label: "任务发起时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.processInstanceStartTime)), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quickList), (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "item",
          onClick: $event => clickMore(item.url)
        }, [_createVNode(_component_el_icon, {
          size: "22"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1)], 8, _hoisted_13);
      }), 128))])]), _createVNode(_component_el_row, {
        gutter: 20,
        style: {
          "margin-bottom": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_icon, {
              size: "20",
              onClick: _cache[1] || (_cache[1] = $event => clickMore('sendOfficialDoc'))
            }, {
              default: _withCtx(() => [_createVNode(_component_More)]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: _unref(officialDocWidgetDataList),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                type: "index",
                width: "50",
                fixed: "left"
              }), _createVNode(_component_el_table_column, {
                prop: "title",
                label: "标题"
              }), _createVNode(_component_el_table_column, {
                prop: "yearStr",
                label: "年份"
              }), _createVNode(_component_el_table_column, {
                prop: "numStr",
                label: "第几号文"
              }), _createVNode(_component_el_table_column, {
                prop: "enterpriseCharacter",
                label: "企字"
              }), _createVNode(_component_el_table_column, {
                prop: "securityLevelDictMap",
                label: "保密级别"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.securityLevelDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "securityRangeDictMap",
                label: "保密期限"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.securityRangeDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "urgencyDictMap",
                label: "紧急程度"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.urgencyDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "openLevelDictMap",
                label: "公开级别"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.openLevelDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "sendDate",
                label: "发文日期"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.sendDate, 'day')), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "sendDept",
                label: "发文机构"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.sendDept), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "receiveDept",
                label: "收文机构"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.receiveDept), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "sendStatusDictMap",
                label: "发文状态"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.sendStatusDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "createUserName",
                label: "创建人"
              }), _createVNode(_component_el_table_column, {
                prop: "createTime",
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.createTime, 'day')), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                fixed: "right",
                width: "150"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  onClick: _withModifiers($event => onPreviewClick(scope.row), ["stop"]),
                  disabled: !_unref(checkPermCodeExist)('formOfficialDoc:formOfficialDoc:preview')
                }, {
                  default: _withCtx(() => [_createTextVNode(" 预览 ")]),
                  _: 2
                }, 1032, ["onClick", "disabled"]), scope.row.sendStatus == 0 ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  type: "danger",
                  onClick: _withModifiers($event => onSendClick(scope.row), ["stop"]),
                  disabled: !_unref(checkPermCodeExist)('formOfficialDoc:formOfficialDoc:send')
                }, {
                  default: _withCtx(() => [_createTextVNode(" 已发文 ")]),
                  _: 2
                }, 1032, ["onClick", "disabled"])) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_el_icon, {
              size: "20",
              onClick: _cache[2] || (_cache[2] = $event => clickMore('receiverOfficialDoc'))
            }, {
              default: _withCtx(() => [_createVNode(_component_More)]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: _unref(receiveOfficialDocList),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                type: "index",
                width: "50",
                fixed: "left"
              }), _createVNode(_component_el_table_column, {
                prop: "title",
                label: "标题"
              }), _createVNode(_component_el_table_column, {
                prop: "yearStr",
                label: "年份"
              }), _createVNode(_component_el_table_column, {
                prop: "numStr",
                label: "第几号文"
              }), _createVNode(_component_el_table_column, {
                prop: "enterpriseCharacter",
                label: "企字"
              }), _createVNode(_component_el_table_column, {
                prop: "securityLevelDictMap",
                label: "保密级别"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.securityLevelDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "securityRangeDictMap",
                label: "保密期限"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.securityRangeDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "urgencyDictMap",
                label: "紧急程度"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.urgencyDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "openLevelDictMap",
                label: "公开级别"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.openLevelDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "sendDate",
                label: "发文日期"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.sendDate, 'day')), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "sendDept",
                label: "发文机构"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.sendDept), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "receiveDept",
                label: "收文机构"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.receiveDept), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "status",
                label: "发文状态"
              }), _createVNode(_component_el_table_column, {
                prop: "flowStatus",
                label: "流程状态"
              }), _createVNode(_component_el_table_column, {
                prop: "createUserName",
                label: "创建人"
              }), _createVNode(_component_el_table_column, {
                prop: "createTime",
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.createTime, 'day')), 1)]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_el_icon, {
              size: "20",
              onClick: _cache[3] || (_cache[3] = $event => clickMore('OfficeOrderPageList'))
            }, {
              default: _withCtx(() => [_createVNode(_component_More)]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: _unref(officeSupplyOrderList),
              style: {
                "width": "100%"
              },
              onCellClick: onFormOfficeStoreEditClick
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "orderDate",
                label: "采购日期"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.orderDate, 'day')), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "applyTotalAmount",
                label: "申请总金额(元)"
              }), _createVNode(_component_el_table_column, {
                prop: "deliveryDate",
                label: "到货日期"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.deliveryDate, 'day')), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "",
                label: "入库总金额(元)"
              }), _createVNode(_component_el_table_column, {
                prop: "statusDictMap",
                label: "状态"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.statusDictMap?.name), 1)]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_component_el_icon, {
              size: "20",
              onClick: _cache[4] || (_cache[4] = $event => clickMore('OfficeUseApplyPageList'))
            }, {
              default: _withCtx(() => [_createVNode(_component_More)]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: _unref(officeUseApplyList),
              style: {
                "width": "100%"
              },
              onCellClick: onOfficeUseApplyGrantClick
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "applyDeptName",
                label: "领用部门"
              }), _createVNode(_component_el_table_column, {
                prop: "applyUserName",
                label: "领用人"
              }), _createVNode(_component_el_table_column, {
                prop: "statusDictMap",
                label: "业务状态"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row?.statusDictMap?.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "applyDate",
                label: "申请日期"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(formatDateByStatsType)(scope.row.applyDate)), 1)]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});